/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import {
  TabbedForm,
  TextInput,
  NumberInput,
  FormTab,
  required,
} from 'react-admin';
import Grid from '@material-ui/core/Grid';

import PreviewPlaceholder from '../../components/PreviewPlaceholder';
import AssetsView from '../../components/AssetsView';
import StatusSelectorInput from '../../components/StatusSelectorInput';
import TagsInput from '../../components/TagsInput';
import PreviewFileInput from '../../components/PreviewFileInput';
import Overlay from '../../components/Overlay';
import validateCollection from './validation';

const CreateOrUpdateFrom = (props) => {
  const { loading } = props;

  return (
    <div style={{ position: 'relative' }}>
      {loading && <Overlay />}
      <TabbedForm {...props} validate={validateCollection}>
        <FormTab label="Base fields">
          <React.Fragment>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Grid item>
                <TextInput source="title" validate={[required()]} />
              </Grid>
              <Grid item>
                <NumberInput source="weight" />
              </Grid>
              <Grid item>
                <StatusSelectorInput source="status" />
              </Grid>
            </Grid>
            <TextInput source="blogLink" fullWidth />
            <TextInput source="blogSummary" fullWidth multiline />
            <TextInput
              source="description"
              fullWidth
              multiline
              validate={[required()]}
            />
            <TagsInput label="Tags" source="tags" />
            <PreviewFileInput
              source="imageUrl"
              placeholder={<PreviewPlaceholder />}
            />
          </React.Fragment>
        </FormTab>
        <FormTab label="Assets">
          <AssetsView source="assets.items" />
        </FormTab>
      </TabbedForm>
    </div>
  );
};

export default CreateOrUpdateFrom;
